
import { AuthState } from '@okta/okta-auth-js';
import { Server } from '../../Shared/Util/Server';

export function fetchSummary(auth: AuthState): Promise<Api.ISummaryResponse|null> {
  return Server.get<Api.ISummaryResponse>(`/response/summary`, auth);
}
